<style lang="less" scoped>
  .syphotoList{position: relative;width: 100%;display: flex;flex-direction: column;font-family: AlibabaPuHuiTi-Medium;}
  .content{width: 1200px;margin: 20px auto;}
  ul{margin: 0;padding: 0;list-style: none;display: flex;flex-wrap: wrap;}
  li{margin: 10px;}
  img{width: 580px;height: 380px;}
  p{width: 580px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
  .el-pagination {text-align: center;}
  .pagination{margin: 20px auto;}
</style>

<template>
  <div class="syphotoList">
    <div class="content">
      <ul>
        <li v-for="(item, index) in photoList" :key="index">
          <img :src="item.thumb" @click="getDetail(item.id)" />
          <p>{{ item.title }}</p>
        </li>
      </ul>

      <div class="block">
        <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 何宽
 * 2022.4.22
 * 首页图片列表页面
 */

export default {
  components: {},
  name: '',
  data()
  {
    return {
      photoList: [],
      count: 10,
      pageSize: 10,
      currentPage: 1,
      countSum: null
    }
  },

  created()
  {
    this.getList()
  },
 
  methods: {
    getList()
    {
      let count = this.count
      let currentPage = this.currentPage
      let paras = {cmd: 'query', _major: 11, _minor: 112, _exp: 'id>0', init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'orders ASC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.countSum = ret[0].total
        this.tableData = []
        ret[0].data.forEach(item =>
        {
          item.thumb = item.thumb.split(',')[0]
        })
        this.photoList = ret[0].data
      })
    },
    getDetail(val)
    {
      let url = this.$router.resolve({path: '/SYphotoDetails', query: {id: val}})
      window.open(url.href, '_blank')
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    search()
    {
      this.getList()
      this.handleSizeChange(this.count)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/SYphotoList.vue